var _desc, _defs, _path, _use, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _use2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "285px",
    height: "143px",
    viewBox: "0 0 285 143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "29.5 112.5 114.5 112.5 114.5 30.5 29.5 30.5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 85,
    height: 82,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "165.5 116.5 258.5 116.5 258.5 78.5 165.5 78.5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 93,
    height: 38,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-5",
    width: 4,
    height: 4,
    x: 161.5,
    y: 74.5,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-6"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-6",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-2",
    transform: "translate(-580.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-5",
    transform: "translate(580.500000, 112.500000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,128 L130,128 L130,15 L14,15 L14,128 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Stroke-2",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14 L26,0",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44,14 L44,0",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63,14 L63,0",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81,14 L81,0",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118,14 L118,0",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100,14 L100,0",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26,142 L26,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44,142 L44,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63,142 L63,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81,142 L81,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118,142 L118,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100,142 L100,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130,26 L144,26",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130,44 L144,44",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130,62 L144,62",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130,80 L153,80",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130,97 L153,97",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130,115 L153,115",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0,26 L14,26",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0,44 L14,44",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0,62 L14,62",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0,80 L14,80",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0,97 L14,97",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0,115 L14,115",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154,128 L270,128 L270,67 L154,67 L154,128 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Stroke-2",
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    fill: "url(#pattern-5)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003,
    points: "165.5 116.5 258.5 116.5 258.5 78.5 165.5 78.5"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M166,66 L166,56",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M184,66 L184,56",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203,66 L203,56",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M221,66 L221,56",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M258,66 L258,56",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M240,66 L240,56",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M166,138 L166,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184,138 L184,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M203,138 L203,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M221,138 L221,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M258,138 L258,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240,138 L240,128",
    id: "Line-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M270,80 L284,80",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M270,97 L284,97",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M270,115 L284,115",
    id: "Line-5",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    strokeLinecap: "square"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration5);
export default __webpack_public_path__ + "static/media/illustration-5.bf5390f74c939247d821c9b44e9fac57.svg";
export { ForwardRef as ReactComponent };